/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Summary_Headline_AccentInputs */

const en_us2_wrapped_summary_headline_accent = /** @type {(inputs: Wrapped_Summary_Headline_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`closed.`)
};

const pt_br2_wrapped_summary_headline_accent = /** @type {(inputs: Wrapped_Summary_Headline_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fechada.`)
};

const es_419_wrapped_summary_headline_accent = /** @type {(inputs: Wrapped_Summary_Headline_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cerrada.`)
};

const pt_pt2_wrapped_summary_headline_accent = /** @type {(inputs: Wrapped_Summary_Headline_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fechada.`)
};

const fr_fr2_wrapped_summary_headline_accent = /** @type {(inputs: Wrapped_Summary_Headline_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bouclée.`)
};

const de_de2_wrapped_summary_headline_accent = /** @type {(inputs: Wrapped_Summary_Headline_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`geschafft.`)
};

const it_it2_wrapped_summary_headline_accent = /** @type {(inputs: Wrapped_Summary_Headline_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chiusa.`)
};

/**
* | output |
* | --- |
* | "closed." |
*
* @param {Wrapped_Summary_Headline_AccentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_summary_headline_accent = /** @type {((inputs?: Wrapped_Summary_Headline_AccentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Summary_Headline_AccentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_summary_headline_accent(inputs)
	if (locale === "es-419") return es_419_wrapped_summary_headline_accent(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_summary_headline_accent(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_summary_headline_accent(inputs)
	if (locale === "de-DE") return de_de2_wrapped_summary_headline_accent(inputs)
	if (locale === "it-IT") return it_it2_wrapped_summary_headline_accent(inputs)
	return en_us2_wrapped_summary_headline_accent(inputs)
});
export { wrapped_summary_headline_accent as "wrapped.summary_headline_accent" }